import { createSchemaDefinition, schemaJSON } from "@mml-io/mml-schema";

const schemaDefinition = createSchemaDefinition(schemaJSON);

export const mmlElements = Object.values(schemaDefinition.elements)
  .filter((element) => element.name.startsWith("m-"))
  .map((element) => element.name);

export const mmlElementSet = new Set(mmlElements);
